import Home from '@/views/Code/Home';

export default [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/logowanie',
    name: 'login',
    component: () => import(/* webpackChunkName: "code.login" */ '@/views/Code/Login.vue'),
  },
];
